import Vue from 'vue'
import Component from 'vue-class-component'

import {
  FILTER_BY_CATEGORY_KEY,
  SEARCH_CONFIG_KEY,
} from '@/constants'
import { Path } from '@/types'

// eslint-disable-next-line no-use-before-define
@Component<FilterByCategoryMixin>({
  watch: {
    selectedCategory (category) {
      this.$typedStore.public.search.setFilterRecords(Boolean(category))
    },
    filterByLocationActive (isActive) {
      if (isActive) {
        this.selectedCategory = null
      }
    },
  },
})
export default class FilterByCategoryMixin extends Vue {
  get filterByCategoryConfig () {
    return FILTER_BY_CATEGORY_KEY in this.$typedStore.activeVisualisation.visualisationStore.app.config ? this.$typedStore.activeVisualisation.visualisationStore.app.config[FILTER_BY_CATEGORY_KEY] : {
      enable: false,
      title: '',
      label: '',
      category: null,
    }
  }

  get title () {
    return this.filterByCategoryConfig.title
  }

  get label () {
    return this.filterByCategoryConfig.label
  }

  get category () {
    return this.filterByCategoryConfig.category
  }

  get searchSettingsConfig () {
    return SEARCH_CONFIG_KEY in this.$typedStore.activeVisualisation.visualisationStore.app.config ? this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY] : {
      enableSearchByLocation: false,
    }
  }

  get enableSearchByLocation () {
    return this.searchSettingsConfig.enableSearchByLocation
  }

  get selectedCategory () {
    return this.$typedStore.public.search.filterByCategorySelected
  }

  set selectedCategory (selected) {
    this.$typedStore.public.search.setFilterByCategorySelected(selected)
  }

  get options () {
    return [
      { value: null, text: 'All' },
      ...this.$typedStore.visualisationData.fieldLeafDataUnique(Path.root, this.category)
        .sort()
        .map((field) => ({ value: field, text: field })),
    ]
  }

  get filterByLocationActive () {
    const { currentLocation, filterRecords } = this.$typedStore.public.search
    return this.enableSearchByLocation && filterRecords && !this.$typedStore.activeVisualisation.visualisationStore.app.isEmpty(currentLocation)
  }
}
